import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: 'design-preview',
		component: () => import('./views/DesignPreview.vue'),
		children: [
			{
				path: 'inputs',
				component: () => import('./views/InputPreview.vue'),
			},
			{
				path: 'button',
				component: () => import('./views/ButtonPreview.vue'),
			},
			{
				path: 'button-alt',
				component: () => import('./views/ButtonAltPreview.vue'),
			},
			{
				path: 'button-link',
				component: () => import('./views/LinkPreview.vue'),
			},
			{
				path: 'button-compact',
				component: () => import('./views/CompactPreview.vue'),
			},
			{
				path: 'button-command',
				component: () => import('./views/CommandButtonPreview.vue'),
			},
			{
				path: 'alert',
				component: () => import('./views/AlertPreview.vue'),
			},
			{
				path: 'badges',
				component: () => import('./views/BadgePreview.vue'),
			},
			{
				path: 'checkbox',
				component: () => import('./views/CheckBoxPreview.vue'),
			},
			{
				path: 'progress-bar',
				component: () => import('./views/ProgressBarPreview.vue'),
			},
			{
				path: 'progress-bar-circle',
				component: () => import('./views/ProgressCirclePreview.vue'),
			},
			{
				path: 'avatar',
				component: () => import('./views/AvatarPreview.vue'),
			},
			{
				path: 'header',
				component: () => import('./views/HeaderPreview.vue'),
			},
			{
				path: 'profile-section',
				component: () => import('./views/ProfileSectionPreview.vue'),
			},
			{
				path: 'table',
				component: () => import('./views/TablePreview.vue'),
			},
			{
				path: 'table-alt',
				component: () => import('./views/TableAltPreview.vue'),
			},
			{
				path: 'kanban',
				component: () => import('./views/KanbanPreview.vue'),
			},
			{
				path: 'dropdown',
				component: () => import('./views/DropdownPreview.vue'),
			},
			{
				path: 'switch',
				component: () => import('./views/SwitchPreview.vue'),
			},
			{
				path: 'breadcrumbs',
				component: () => import('./views/BreadcrumbsPreview.vue'),
			},
			{
				path: 'toggle',
				component: () => import('./views/TogglePreview.vue'),
			},
			{
				path: 'radio',
				component: () => import('./views/RadioPreview.vue'),
			},
			{
				path: 'selection-group',
				component: () => import('./views/SelectionPreview.vue'),
			},
			{
				path: 'modals',
				component: () => import('./views/ModalPreview.vue'),
			},
			{
				path: 'datepicker',
				component: () => import('./views/DatePickerPreview.vue'),
			},
			{
				path: 'form-section',
				component: () => import('./views/FormSectionPreview.vue'),
			},
			{
				path: 'dateFormated',
				component: () => import('./views/DateFormatedPreview.vue'),
			},
			{
				path: 'tab',
				component: () => import('./views/TabPreview.vue'),
			},
			{
				path: 'filter-dropdown',
				component: () => import('./views/FilterDropdownPreview.vue'),
			},
			{
				path: 'ongoing-propositions-dropdown',
				component: () =>
					import('./views/OngoingPropositionsDropdownPreview.vue'),
			},
		],
	},
];

export default routes;
